// Module
var code = `<ex-erreur-chargement class="m-t-40" lbl-message="G_MSG_CHARG" retry-action="vm.reload()" retrying="vm.reloading"> </ex-erreur-chargement> `;
// Exports
module.exports = code;